'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.licenceHeldOptions = undefined;
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _select = require('../components/select');
var _select2 = _interopRequireDefault(_select);
var _propTypes = require('prop-types');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}
var licenceHeldOptions = exports.licenceHeldOptions = [{
  text: 'Less than 6 months',
  value: '5'
}, {
  text: '6 months to 1 year',
  value: '11'
}, {
  text: '1 to 1.5 years',
  value: '17'
}, {
  text: '1.5 to 2 years',
  value: '23'
}, {
  text: '2 to 2.5 years',
  value: '29'
}, {
  text: '2.5 to 3 years',
  value: '35'
}, {
  text: '3 to 4 years',
  value: '47'
}, {
  text: '4 to 5 years',
  value: '59'
}, {
  text: 'Over 5 years',
  value: '60'
}];
LicenceHeld.propTypes = {
  label: _propTypes.string
};
LicenceHeld.defaultProps = {
  label: 'How long have you held your licence?'
};
function LicenceHeld(_ref) {
  var label = _ref.label,
    rest = _objectWithoutProperties(_ref, ['label']);
  return _react2.default.createElement(_select2.default, Object.assign({
    name: 'licenceHeld',
    label: label,
    placeholder: 'Select length',
    options: licenceHeldOptions
  }, rest));
}
exports.default = LicenceHeld;